export default {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setAccessGroups(state, accessGroups) {
    state.accessGroups = accessGroups;
  },
  setAccessGroup(state, accessGroup) {
    state.accessGroup = accessGroup;
  },
  setPermissions(state, permissions) {
    state.permissions = permissions;
  },
  setGroups(state, groups) {
    state.groups = groups;
  },
  setGroup(state, group) {
    state.group = group;
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/access-groups/store/mutations.js